// extracted by mini-css-extract-plugin
module.exports = {"send-for-confirmation-popup":"SendForConfirmationPopup_send-for-confirmation-popup__zJZG_"};